
import ReactDOM from 'react-dom/client';
import Page from './Page';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./store";
// import { AlitaProvider } from 'redux-alita';

// ui
import './style/antd/index.less';

// site
import './style/site/bootstrap.min.css';
import './style/site/responsive.css';
import './style/site/swiper.min.css';
import './style/site/style.css';

// global
import './index.less';

import { mockXHR } from './mock';
mockXHR();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <Page />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
